import { z } from 'zod'

export const GetLiquidityBreakdownsByExchangeQuery = z.object({
  date: z.string().date(),
  marketMakerId: z.string().nullish(),
  orderBook: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().nullish(),
})

export const GetLiquidityBreakdownsQuery = GetLiquidityBreakdownsByExchangeQuery.extend({
  exchangeId: z.string().nullish(),
})

export type GetLiquidityBreakdownsQueryType = z.infer<typeof GetLiquidityBreakdownsQuery>
export type GetLiquidityBreakdownsByExchangeQueryType = z.infer<typeof GetLiquidityBreakdownsQuery>

const GetLiquidityBreakdownsByExchangeEntry = z.object({
  exchangeId: z.string(),
  exchangeName: z.string(),
  ask100: z.number().safe(),
  ask100Percentage: z.number().safe(),
  ask200: z.number().safe(),
  ask200Percentage: z.number().safe(),
  ask50: z.number().safe(),
  ask50Percentage: z.number().safe(),
  bid100: z.number().safe(),
  bid100Percentage: z.number().safe(),
  bid200: z.number().safe(),
  bid200Percentage: z.number().safe(),
  bid50: z.number().safe(),
  bid50Percentage: z.number().safe(),
  bidAsk100: z.number().safe(),
  bidAsk100Percentage: z.number().safe(),
  bidAsk200: z.number().safe(),
  bidAsk200Percentage: z.number().safe(),
  bidAsk50: z.number().safe(),
  bidAsk50Percentage: z.number().safe(),
})

const GetLiquidityBreakdownsEntry = GetLiquidityBreakdownsByExchangeEntry.omit({
  exchangeId: true,
  exchangeName: true,
}).extend({
  allOthersAsk100: z.number().safe(),
  allOthersAsk100Percentage: z.number().safe(),
  allOthersAsk200: z.number().safe(),
  allOthersAsk200Percentage: z.number().safe(),
  allOthersAsk50: z.number().safe(),
  allOthersAsk50Percentage: z.number().safe(),
  allOthersBid100: z.number().safe(),
  allOthersBid100Percentage: z.number().safe(),
  allOthersBid200: z.number().safe(),
  allOthersBid200Percentage: z.number().safe(),
  allOthersBid50: z.number().safe(),
  allOthersBid50Percentage: z.number().safe(),
  allOthersBidAsk100: z.number().safe(),
  allOthersBidAsk100Percentage: z.number().safe(),
  allOthersBidAsk200: z.number().safe(),
  allOthersBidAsk200Percentage: z.number().safe(),
  allOthersBidAsk50: z.number().safe(),
  allOthersBidAsk50Percentage: z.number().safe(),
  overreportingAsk200: z.number().safe(),
  overreportingBid200: z.number().safe(),
  overreportingBidAsk200: z.number().safe(),
  warnings: z
    .object({
      ask200: z.boolean(),
      bid200: z.boolean(),
      bidAsk200: z.boolean(),
    })
    .nullable(),
})

export const GetLiquidityBreakdownsResult = z.array(GetLiquidityBreakdownsEntry)
export const GetLiquidityBreakdownsByExchangeResult = z.array(GetLiquidityBreakdownsByExchangeEntry)
